import { render } from "./carousel-item.vue?vue&type=template&id=85f11e06"
import script from "./carousel-item.vue?vue&type=script&lang=js"
export * from "./carousel-item.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/RelaxPlus/RelaxPlus/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__